import React from 'react';
import ReportDetails from '../ReportDetails';

import {
  MACHINE_TO_MACHINE_DESCRIPTION,
  MACHINE_TO_MACHINE_DESCRIPTION_FOR_APPLIANCE
} from '../../utils/resources/reports';

const ReportDetailsMachineToMachineAuth = props => <ReportDetails {...props} />;

ReportDetailsMachineToMachineAuth.defaultProps = {
  title: 'Machine to Machine Auth',
  subtitle: 'last month',
  description: MACHINE_TO_MACHINE_DESCRIPTION,
  descriptionForAppliance: MACHINE_TO_MACHINE_DESCRIPTION_FOR_APPLIANCE,
  quantityName: 'Authentication Calls',
  tabs: [
    {
      title: 'Authentication Calls',
      selector: 'apiCallsByMonth',
      csvFilename: 'apiCallsByMonth',
      csvDescription:
        'This table shows monthly Authentication Calls for the past 12 months of the subscription.',
      csvColumns: {
        month: 'Month',
        api_calls: 'Authentication Calls'
      },
      headers: [
        {
          title: 'Month'
        },
        {
          title: 'Authentication Calls'
        }
      ],
      columns: [
        {
          keyName: 'month'
        },
        {
          keyName: 'api_calls'
        }
      ]
    },
    {
      title: 'Authentication Calls by Tenant',
      selector: 'apiCallsByTenantMonth',
      csvFilename: 'apiCallsByTenantMonth',
      csvDescription:
        'This table shows monthly Authentication Calls for each tenant for the past 12 months of the subscription.',
      csvColumns: {
        month: 'Month',
        tenant: 'Tenant',
        api_calls: 'Authentication Calls'
      },
      headers: [
        {
          title: 'Month'
        },
        {
          title: 'Tenant',
          keyName: 'tenant',
          isFilter: true
        },
        {
          title: 'Authentication Calls'
        }
      ],
      columns: [
        {
          keyName: 'month'
        },
        {
          keyName: 'tenant',
          isTooltip: true
        },
        {
          keyName: 'api_calls'
        }
      ]
    }
  ],
  applianceTabs: [
    {
      title: 'Authentication Calls',
      selector: 'apiCallsByMonth',
      csvFilename: 'apiCallsByMonth',
      csvDescription:
        'This table shows monthly Authentication Calls for the past 12 months of the subscription.',
      csvColumns: {
        month: 'Month',
        api_calls: 'Authentication Calls'
      },
      headers: [
        {
          title: 'Month'
        },
        {
          title: 'Authentication Calls'
        }
      ],
      columns: [
        {
          keyName: 'month'
        },
        {
          keyName: 'api_calls'
        }
      ]
    },
    {
      title: 'Authentication Calls by Private Instance',
      selector: 'apiCallsByApplianceMonth',
      csvFilename: 'apiCallsByApplianceMonth',
      csvDescription:
        'This table shows monthly Authentication Calls for each private instance for the past 12 months of the subscription.',
      csvColumns: {
        month: 'Month',
        environment: 'Environment',
        root_domain_auth: 'Private Instance',
        api_calls: 'Authentication Calls'
      },
      headers: [
        {
          title: 'Month'
        },
        {
          title: 'Environment',
          keyName: 'environment',
          isFilter: true
        },
        {
          title: 'Private Instance',
          keyName: 'root_domain_auth',
          isFilter: true
        },
        {
          title: 'Authentication Calls'
        }
      ],
      columns: [
        {
          keyName: 'month'
        },
        {
          keyName: 'environment',
          isTooltip: true
        },
        {
          keyName: 'root_domain_auth',
          isTooltip: true
        },
        {
          keyName: 'api_calls'
        }
      ]
    },
    {
      title: 'Authentication Calls by Private Instance by Tenant',
      selector: 'apiCallsByAppplianceByTenantMonth',
      csvFilename: 'apiCallsByApplianceByTenantMonth',
      csvDescription:
        'This table shows monthly Authentication Calls for each private instance and tenant for the past 12 months of the subscription.',
      csvColumns: {
        month: 'Month',
        environment: 'Environment',
        root_domain_auth: 'Private Instance',
        tenant: 'Tenant',
        api_calls: 'Authentication Calls'
      },
      headers: [
        {
          title: 'Month'
        },
        {
          title: 'Environment',
          keyName: 'environment',
          isFilter: true
        },
        {
          title: 'Private Instance',
          keyName: 'root_domain_auth',
          isFilter: true
        },
        {
          title: 'Tenant',
          keyName: 'tenant',
          isFilter: true
        },
        {
          title: 'Authentication Calls'
        }
      ],
      columns: [
        {
          keyName: 'month'
        },
        {
          keyName: 'environment',
          isTooltip: true
        },
        {
          keyName: 'root_domain_auth',
          isTooltip: true
        },
        {
          keyName: 'tenant',
          isTooltip: true
        },
        {
          keyName: 'api_calls'
        }
      ]
    }
  ]
};

export default ReportDetailsMachineToMachineAuth;
